import { render, staticRenderFns } from "./FixedBearingsFormBearingDimension.vue?vue&type=template&id=aa16bd70&scoped=true"
import script from "./FixedBearingsFormBearingDimension.vue?vue&type=script&lang=js"
export * from "./FixedBearingsFormBearingDimension.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa16bd70",
  null
  
)

export default component.exports